import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
export var useTableView = function useTableView() {
  var uniqueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var config = arguments.length > 1 ? arguments[1] : undefined;

  // data list
  var _useState = useState([]),
      tableList = _useState[0],
      setTableList = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(0),
      total = _useState3[0],
      setTotal = _useState3[1];

  var _useState4 = useState([10, 20, 50, 100]),
      pageRowsOptions = _useState4[0],
      setPageRowsOptions = _useState4[1];

  var _useState5 = useState((config === null || config === void 0 ? void 0 : config.pageNoInitialNo) || 0),
      pageNo = _useState5[0],
      setPageNo = _useState5[1];

  var _useState6 = useState(20),
      pageSize = _useState6[0],
      setPageSize = _useState6[1];

  var _useState7 = useState(pageNo * pageSize),
      offset = _useState7[0],
      setOffset = _useState7[1]; // select rows


  var _useState8 = useState([]),
      selectRows = _useState8[0],
      setSelectRows = _useState8[1];

  var _useState9 = useState(false),
      selectAllIndeterminate = _useState9[0],
      setSelectAllIndeterminate = _useState9[1];

  var _useState10 = useState(false),
      selectAllChecked = _useState10[0],
      setSelectAllChecked = _useState10[1];

  var _useState11 = useState([]),
      canSelectList = _useState11[0],
      setCanSelectList = _useState11[1];

  var canSelectKey = (config === null || config === void 0 ? void 0 : config.canSelectKey) || 'canSelect';
  /**
   * effects
   */

  useEffect(function () {
    setCanSelectList(config !== null && config !== void 0 && config.needCanSelect && canSelectKey ? cloneDeep(tableList).filter(function (item) {
      return item[canSelectKey];
    }) : cloneDeep(tableList));
  }, [tableList]);
  useEffect(function () {
    updateSelectRelatedFlag(selectRows);
  }, [canSelectList]);
  /**
   * methods
   */
  // hanlde click change page

  var handleChangePageNo = function handleChangePageNo(event, pageNo) {
    setPageNo(pageNo);
    setOffset(pageNo * pageSize);
  }; // handle change pageSize


  var handleChangePageSize = function handleChangePageSize(event) {
    setPageSize(Number(event.target.value));
    handleChangePageNo(null, 0);
  }; // update select related flag


  var updateSelectRelatedFlag = function updateSelectRelatedFlag(allSelectRows) {
    var selectNum = canSelectList.filter(function (item) {
      return !!allSelectRows.find(function (aItem) {
        return aItem[uniqueId] === item[uniqueId];
      });
    }).length;
    var allSelect = canSelectList.length > 0 && selectNum > 0 && canSelectList.every(function (item) {
      return !!allSelectRows.find(function (aItem) {
        return aItem[uniqueId] === item[uniqueId];
      });
    });
    setSelectAllChecked(allSelect);
    setSelectAllIndeterminate(!allSelect && !!canSelectList.find(function (item) {
      return !!allSelectRows.find(function (aItem) {
        return aItem[uniqueId] === item[uniqueId];
      });
    }));
  }; // update select info


  var triggerSelectRow = function triggerSelectRow(row, event) {
    if (event.target.closest('button')) return;

    if (config !== null && config !== void 0 && config.needCanSelect) {
      if (row[canSelectKey] !== true) {
        return;
      }
    }

    var index = selectRows.findIndex(function (item) {
      return item[uniqueId] === row[uniqueId];
    });
    var list = cloneDeep(selectRows);

    if (index === -1) {
      list.push(cloneDeep(row));
    } else {
      list.splice(index, 1);
    }

    setSelectRows(list);
    updateSelectRelatedFlag(list);
  }; // clean select rows


  var cleanSelectRows = function cleanSelectRows() {
    setSelectRows([]);
    updateSelectRelatedFlag([]);
  }; // trigger select event


  var triggerAllAction = function triggerAllAction(event) {
    var list = [];
    var currentTableList = cloneDeep(config !== null && config !== void 0 && config.needCanSelect ? tableList.filter(function (item) {
      return item[canSelectKey];
    }) : tableList);

    if (!(config !== null && config !== void 0 && config.notSavePageHaveSelected)) {
      if (event.target.checked) {
        list = [].concat(_toConsumableArray(cloneDeep(selectRows)), _toConsumableArray(currentTableList.filter(function (item) {
          return !selectRows.find(function (aItem) {
            return aItem[uniqueId] === item[uniqueId];
          });
        })));
      } else {
        list = selectRows.filter(function (item) {
          return !currentTableList.find(function (aItem) {
            return aItem[uniqueId] === item[uniqueId];
          });
        });
      }
    } else {
      list = event.target.checked ? currentTableList : [];
    }

    setSelectRows(list);
    updateSelectRelatedFlag(list);
  };

  return {
    loading: loading,
    setLoading: setLoading,
    total: total,
    setTotal: setTotal,
    pageRowsOptions: pageRowsOptions,
    setPageRowsOptions: setPageRowsOptions,
    pageNo: pageNo,
    setPageNo: setPageNo,
    pageSize: pageSize,
    setPageSize: setPageSize,
    selectRows: selectRows,
    setSelectRows: setSelectRows,
    handleChangePageNo: handleChangePageNo,
    handleChangePageSize: handleChangePageSize,
    tableList: tableList,
    setTableList: setTableList,
    triggerSelectRow: triggerSelectRow,
    triggerAllAction: triggerAllAction,
    offset: offset,
    setOffset: setOffset,
    selectAllIndeterminate: selectAllIndeterminate,
    selectAllChecked: selectAllChecked,
    cleanSelectRows: cleanSelectRows,
    updateSelectRelatedFlag: updateSelectRelatedFlag
  };
};